<template>
  <div class="home-bg">
    <div class="home">
      <header>
        <div class="tabs">
          <div
            v-for="tab in tabs"
            :key="tab.key"
            :class="['tab-item', { active: current === tab.key }]"
            @click="changeTab(tab.key)"
          >
            {{ tab.tab }}
          </div>
        </div>
        <div class="hotline-wrap">
          <div class="hotline">
            <img src="@/assets/phone.svg" alt="客服热线" class="hotline-img" />
            <span class="hotline-phone">0510-66681818</span>
          </div>
        </div>
      </header>
      <article>
        <router-view />
      </article>
      <footer>
        <span @click="jump"
          >COPYRIGHT© 龙坤(无锡)智慧科技有限公司 ALL RIGHTS RESERVED.
          苏ICP备2021014966号-1</span
        >
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      current: "index",
      top: 0,
      tabs: [
        { key: "index", tab: "首页" },
        { key: "scheme", tab: "解决方案" },
        { key: "case", tab: "经典案例" },
        { key: "about", tab: "关于龙坤" },
        { key: "contact", tab: "联系龙坤" },
        { key: "certificateOfHonor", tab: "荣誉证书" },
      ],
      TAB_KEY: "home_active_tab",
    };
  },
  components: {},
  created() {
    const savedTab = localStorage.getItem(this.TAB_KEY);
    if (savedTab && this.tabs.some((tab) => tab.key === savedTab)) {
      this.current = savedTab;
      if (this.$route.path !== `/home/${savedTab}`) {
        this.$router.replace(`/home/${savedTab}`);
      }
    } else if (this.$route.path === "/home/scheme") {
      this.current = "scheme";
    }
  },
  watch: {
    $route(to) {
      const tabKey = to.path.replace("/home/", "");
      if (this.tabs.some((tab) => tab.key === tabKey)) {
        this.current = tabKey;
      }
    },
  },
  methods: {
    changeTab(key) {
      this.current = key;
      localStorage.setItem(this.TAB_KEY, key);
      this.$router.push(`/home/${key}`);
    },
    jump() {
      window.location.href = "https://beian.miit.gov.cn";
    },
  },
};
</script>

<style lang="less">
.home-bg {
  width: 100%;
  background: #fff;
  // overflow-x: auto;
  // overflow-y: auto;
  min-width: 1500px;
  max-width: 1900px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
}

.home {
  width: 100%;
  max-width: 1900px;
  min-width: 1500px;
  margin: 0 auto;
  height: 100%;
  user-select: none;
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  header {
    width: 100%;
    min-width: 1500px;
    max-width: 1900px;
    height: 88px;
    background: #f3f6fa url("../assets/logo.svg") 10% center no-repeat;
    background-size: 100px 40px;
    display: flex;
    align-items: center;
    position: relative;
    // padding: 0 20px;
    box-sizing: border-box;

    .tabs {
      margin-left: auto;
      margin-right: 20px;
      width: 56%;
      display: flex;
      align-items: center;
      gap: 30px;

      .tab-item {
        padding: 30px 0;
        margin-right: 40px;
        font-size: 18px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        color: #2a2a2a;
        line-height: 28px;
        cursor: pointer;
        position: relative;

        &:last-child {
          margin-right: 0;
        }

        &.active {
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: 500;
          color: #446bfd;

          &::after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 2px;
            background-color: #446bfd;
          }
        }

        &:hover {
          color: #446bfd;
        }
      }
    }
    .hotline-wrap {
      width: 325px;
      .hotline {
        display: flex;
        align-items: center;
        white-space: nowrap;

        .hotline-img {
          width: 16px;
          height: 16px;
          display: block;
        }
        .hotline-phone {
          margin-left: 8px;
          font-size: 18px;
          font-family: DIN, DIN-500;
          font-weight: 500;
          color: #2c3239;
          line-height: 18px;
        }
      }
    }
  }

  article {
    flex: 1;
  }

  footer {
    width: 100%;
    height: 60px;
    background: #050f2a;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: auto;

    span {
      width: 856px;
      height: 18px;
      font-size: 18px;
      font-family: Microsoft YaHei, Microsoft YaHei-400;
      font-weight: 400;
      text-align: center;
      color: #a5abb1;
      line-height: 18px;
      letter-spacing: 0.09px;
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
